<template>
  <div id="print">

    <div class="book m-auto">

      <div
        v-for="(data, idx) in Math.ceil(sale.orders.length/maxOrderLists)"
        :key="idx"
        :style="`font-size: ${fontSize}%;`"
        class="page"
      >
        <div class="subpage">
          <div class="top-header">
            <div
              v-if="idx == 0"
              class="company-info">
              <img
                v-if="shopInfo.logo.thumbnail"
                :src="shopInfo.logo.thumbnail">
              <div class="name">
                <strong class="text-black">{{ shopInfo.shop_name }}</strong>
                <p class="max-line-3">{{ shopInfo.info.location.address }}</p>
                <p
                  v-if="shopInfo.info.vat.taxpayer_no"
                  class="max-line-3">
                  {{ $t('message.taxpayerno') }}:
                  {{ shopInfo.info.vat.taxpayer_no }}
                </p>
                <p
                  v-if="getPartnerContact(shopInfo.contacts).tel"
                  class="max-line-3">
                  {{ $t('message.tel') }}:
                  {{ getPartnerContact(shopInfo.contacts).tel }}
                </p>
              </div>
            </div>
            <div class="document-type">
              <h2 class="text-black">{{ $t('documents.so') }}</h2>
              <p>{{ sale.so_code }}</p>
            </div>
          </div>
          <div
            v-if="idx == 0"
            class="content">
            <div class="left">
              <div class="section">
                <p class="label">{{ $t('message.customer') }}</p>
                <p class="detail">{{ sale.customer.customer_name }}</p>
              </div>
              <div
                v-if="getPartnerContact(sale.customer.contacts).tel"
                class="section">
                <p class="label">{{ $t('message.tel') }}</p>
                <p class="detail">{{ getPartnerContact(sale.customer.contacts).tel }}</p>
              </div>
              <div
                v-if="sale.customer.address"
                class="section">
                <p class="label">{{ $t('message.address') }}</p>
                <p class="detail max-line-4">{{ sale.customer.address }}</p>
              </div>
              <div
                v-if="sale.customer.tax_id"
                class="section">
                <p class="label">{{ $t('message.taxpayerno') }}</p>
                <p class="detail">{{ sale.customer.tax_id }}</p>
              </div>
            </div>
            <div class="right">
              <div class="section">
                <p class="label">{{ $t('message.date') }}</p>
                <p class="detail">{{ getDate(sale.created_at) }}</p>
              </div>
              <div class="section">
                <p class="label">{{ $t('message.credittype') }}</p>
                <template>
                  <p
                    v-if="sale.credit.type == 'cash'"
                    class="detail">{{ $t('message.cash') }}</p>
                  <p
                    v-else
                    class="detail">{{ $t('message.creditdasys', {number: sale.credit.days}) }}</p>
                </template>
              </div>
              <div
                v-if="sale.credit.type == 'days'"
                class="section">
                <p class="label">{{ $t('message.scheduled_at') }}</p>
                <p class="detail">{{ getDate(sale.scheduled_at) }}</p>
              </div>
            </div>
          </div>
          <div class="order">
            <table>
              <thead>
                <tr>
                  <td width="10px"><b>#</b></td>
                  <td><b>{{ $t('message.description') }}</b></td>
                  <td class="text-right"><b>{{ $t('message.quantity') }}</b></td>
                  <td
                    class="text-right"
                    style="min-width: 100px;"><b>{{ $t('message.unitprice') }}</b></td>
                  <td
                    v-if="total.discount > 0 && foundDiscount"
                    class="text-right"><b>{{ $t('message.discount') }}</b></td>
                  <td class="text-right"><b>{{ $t('message.total') }}</b></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx_) in groupOrders[idx].orders"
                  :key="idx_"
                >
                  <td width="10px"><b>{{ (maxOrderLists*idx)+(idx_+1) }}</b></td>
                  <td>{{ item.description }}</td>
                  <td class="text-right">{{ getNumber(item.quantity) }}</td>
                  <td class="text-right">{{ getNumber(item.price) }}</td>
                  <td
                    v-if="total.discount > 0 && foundDiscount"
                    class="text-right">
                    <span v-if="getDiscountInfo(item)">
                      <template>
                        <span v-if="getDiscountInfo(item).type == 'percentage'">{{ getNumber(getDiscountInfo(item).amount) }}%</span>
                        <span v-else>{{ getNumber(getDiscountInfo(item).amount) }} {{ currency }}</span>
                      </template>
                    </span>
                  </td>
                  <td class="text-right">{{ getNumber(getOrderTotal(item)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="Math.ceil(sale.orders.length/maxOrderLists) > 0 && idx !== (Math.ceil(sale.orders.length/maxOrderLists)-1)"
            class="next-page">
            {{ $t('message.havenextpage') }}
          </div>

          <div
            v-if="idx >= (Math.ceil(sale.orders.length/maxOrderLists)-1)"
            class="footer">

            <div class="note">
              <div
                v-if="sale.note"
                class="section">
                <p>{{ $t('message.note') }}</p>
                <p style="white-space: pre;word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">{{ sale.note }}</p>
              </div>
            </div>

            <div class="total">

              <div class="section">

                <div
                  v-if="foundDiscount || foundTaxes"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.total') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.sub) }}
                  </div>
                </div>

                <div
                  v-if="total.discount > 0 && foundDiscount"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.discount') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.discount) }}
                  </div>
                </div>

                <div
                  v-if="total.discount > 0 && foundDiscount"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.discounted_total') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.sub - total.discount) }}
                  </div>
                </div>

                <div
                  v-if="total.taxes.vat.inclusive > 0 && foundTaxes"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ $t('message.totalexcludingvat') }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(total.untaxed) }}
                  </div>
                </div>

                <div
                  v-for="(tax, index) in taxResults"
                  :key="index"
                  class="section row m-0">
                  <div class="label mb-2">
                    {{ tax.displayText }}
                  </div>
                  <div class="detail mb-2 text-right">
                    {{ getNumber(tax.total) }}
                  </div>
                </div>

                <div class="section row m-0">
                  <div class="label">
                    {{ $t('message.grandtotal') }}
                  </div>
                  <div class="detail text-right">
                    <span class="text-underline-border">
                      {{ getNumber(total.grand) }}
                    </span>
                  </div>
                </div>

              </div>

            </div>

            <div :class="['signature', { 'non-fixed-bottom': !isFixedSignatureBottom }]">
              <div class="left">
                <div class="title max-line-1">
                  {{ sale.customer.customer_name }}
                </div>
                <div class="info">
                  <div class="name">
                    {{ $t('message.name') }}
                  </div>
                  <div class="date">
                    {{ $t('message.date') }}
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="title max-line-1">
                  {{ shopInfo.shop_name }}
                </div>
                <div class="info">
                  <div class="name">
                    <p style="margin: 0;">
                      <span
                        v-if="shopInfo.shop_id === '63d8813021671ace1eb7269b'"
                        style="margin: 0;">
                        ศุภวัฒน์ เด่นสมุทร
                      </span>
                      <span v-else>
                        {{ $t('message.name') }}
                      </span>
                    </p>
                    <p
                      v-if="shopInfo.shop_id === '63d8813021671ace1eb7269b'"
                      style="margin: 0;">
                      ขอแสดงความนับถือ
                    </p>
                  </div>
                  <div class="date">
                    {{ $t('message.date') }}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    sale: {
      type: Object,
    },
    fontSize: {
      type: Number,
    },
    isFixedSignatureBottom: {
      type: Boolean,
    },
  },
  data () {
    return {
      maxOrderLists: 15,
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      getPartnerContact: 'getPartnerContact',
      currency: 'getCurrency',
    }),
    total () {
      return this.getTotal(this.sale.orders)
    },
    taxResults () {
      const isGroupTaxName = false
      return this.getTaxesByOrders(this.sale.orders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
    vatRate () {
      var vatPercent = undefined
      for (let i in this.sale.orders) {
        let order = this.sale.orders[i]
        for (let j in order.taxes) {
          let tax = order.taxes[j]
          if (tax.name == '{vat}') {
            vatPercent = tax.amount
          }
        }
      }
      return vatPercent
    },
    whtRate () {
      var whtPercent = undefined
      for (let i in this.sale.orders) {
        let order = this.sale.orders[i]
        for (let j in order.taxes) {
          let tax = order.taxes[j]
          if (tax.name == '{wht}') {
            whtPercent = tax.amount
          }
        }
      }
      return whtPercent
    },
    foundDiscount () {
      var found = false
      this.sale.orders.map(order => {
        if (order.discounts.length > 0) found = true
      })
      return found
    },
    foundTaxes () {
      var found = false
      this.sale.orders.map(order => {
        if (order.taxes.length > 0) found = true
      })
      return found
    },
    groupOrders () {
      var results = []
      var currentIdx = 0

      for (let i = 0; i < Math.ceil(this.sale.orders.length / this.maxOrderLists); i++) {
        var page = i + 1
        results.push({
          'page': page,
          'orders': [],
        })
      }

      for (let i = 0; i < this.sale.orders.length; i++) {
        let order = this.sale.orders[i]

        if (i % (this.maxOrderLists) == 0 && i !== 0) {
          currentIdx++
        }

        results[currentIdx].orders.push(order)
      }

      return results
    },
  },
  methods: {
    ...mapActions([

    ]),
    getDiscountInfo (order) {
      var discountType = null
      var discountAmount = null

      for (let i in order.discounts) {
        discountType = order.discounts[i].value_type
        discountAmount = order.discounts[i].value_amount
      }

      if (!discountType && !discountAmount) {
        return null
      }

      return {
        type: discountType,
        amount: discountAmount,
      }
    },
    getVatInfo (order) {
      var taxType = null
      var taxAmount = null

      for (let i in order.taxes) {
        if (order.taxes[i].name == '{vat}') {
          taxType = order.taxes[i].type
          taxAmount = order.taxes[i].amount
        }
      }

      if (!taxType && !taxAmount) {
        return null
      }

      return {
        type: taxType,
        amount: taxAmount,
      }
    },
    getOrderTotal (order) {
      var total = 0

      var discountType = null
      var discountAmount = null

      var taxType = null
      var taxAmount = null

      let discountInfo = this.getDiscountInfo(order)
      let taxInfo = this.getVatInfo(order)

      let price = parseFloat(order.price)
      price = price || 0
      let quantity = parseFloat(order.quantity)
      quantity = quantity || 0
      let subtotal = price * quantity

      if (discountInfo) {
        discountType = discountInfo.type
        discountAmount = discountInfo.amount
      }

      if (taxInfo) {
        taxType = taxInfo.type
        taxAmount = taxInfo.amount
      }

      // discount
      if (!discountType) {
        total = subtotal
      } else {
        if (discountType == 'percentage') {
          total = (subtotal) * ((100 - discountAmount) / 100)
        } else {
          total = subtotal - discountAmount
        }
      }

      // untaxed
      if (taxType == 'include') {
        total = total * 100 / (100 + taxAmount)
      }

      return this.currencyFormatter(total, { code: this.currency, symbol: '' }).replace(/,/g, '')
    },
  },
  created: async function () {

  },
  mounted: function () {

  },
}
</script>

<style scoped>
  @page {
      size: A4;
      margin: 0;
  }

  @media print {
      #print .page {
          margin: 0;
          border: initial;
          border-radius: initial;
          width: initial;
          min-height: initial;
          box-shadow: initial;
          background: initial;
          page-break-after: always;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/sales/so/include/PrintSale.vue